import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController, AlertController, ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { Globals } from '../../../../globals';
import { ConfigurationServices } from '../../services';
import { TPVServices } from '../../../tpv/services';
import { HttpParams, HttpClient } from '@angular/common/http';


@Component({
  selector: 'page-configuration-view-charge',
  templateUrl: 'configuration-view-charge.html',
})
export class ConfigurationViewChargePage {

  charge: any;
  ticket: any;
  lists: any = [];
  list_show: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private alertCtrl: AlertController,
    public globals: Globals,
    public translate: TranslateService,
    private configurationServices: ConfigurationServices,
    public toastCtrl: ToastController,
    public tpvServices: TPVServices,
    private http: HttpClient,) {

    this.charge = this.navParams.get('charge');
    if (this.charge.uid_ticket) {
      this.getTicketOfCharge(this.charge.uid_ticket);
    }

  }

  async getTicketOfCharge(uid_ticket) {
    this.ticket = await this.configurationServices.getTicket(uid_ticket);

    for (let k in this.ticket.list) {
      this.lists.push(this.ticket.list[k]);
    }

    this.list_show = this.tpvServices.listSelectedTicket('name', this.lists)[0];
  }


  async refundCharge(charge) {

    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-devolucion-pago'),
      message: this.translate.instant('instant-seguro-hacer-devolucion'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => {
          }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.refund(charge);
          }
        }
      ]
    });
    alert.present();
  }

  async refund(charge) {
    var loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();

    const params = new HttpParams()
      .set('charge_id', charge.id)
      .set('public_key', this.globals.public_key)
      .set('doc_charge', charge.UID);

    const response = await this.http.post(this.globals.analytics_path + 'stripe/refundStripeChargeRestaurant2Customer', params, {}).toPromise();

    if (response['refund']) {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-refund-ok'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('instant-refund-error'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }

    loadingPopup.dismiss();
  }



}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-payments-charges/configuration-view-charge/configuration-view-charge.ts